import styled, { css } from 'styled-components'

const LoadingSpin = styled.div`
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #9e9e9e;
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : '100%')};

  ${({ full }) =>
    full &&
    css`
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 0.5);
    `};

  svg {
    animation: spin 0.9s linear infinite;

    @keyframes spin {
      100% {
        transform: rotate(360deg);
      }
    }
  }
`

export { LoadingSpin }
